import React, { useEffect, useRef, useState } from 'react'
import ProfileContent from '../global/ProfileContent';
import { diferenciaFechas } from '../../utils/goblaFunctions';

import CloseIcon from '@mui/icons-material/Close';

import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';

import VolumeMuteIcon from '@mui/icons-material/VolumeMute';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';

import FullscreenIcon from '@mui/icons-material/Fullscreen';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import MoodIcon from '@mui/icons-material/Mood';

import { useProovedorData } from '../providers/ProovedorData';
import { useSearchParams } from 'react-router-dom';
import CallApi from '../../data/CallApi';

import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import ListIcon from '@mui/icons-material/List';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import BookmarkIcon from '@mui/icons-material/Bookmark';
import TurnedInNotIcon from '@mui/icons-material/TurnedInNot';

import CommentGlobe from '../../svg/CommentGlobe';
import PaperAirplaneIcon from '../../svg/PaperAirplaneIcon';
import ShareIcon from '../../svg/ShareIcon';

import LimitText from '../global/LimitText';
import ButtonLoader from '../global/ButtonLoader';
import { Button } from 'react-bootstrap';
import VideoHighWide from '../../pages/user/video/VideoHighWide';
import { toast } from 'react-toastify';


const API_URL = process.env.REACT_APP_API_URL;

export const VideoViewer = () => {//Video Element
    const [searchParams, setSearchParams] = useSearchParams();

    const videoKey = searchParams.get("v");
    const userKey = searchParams.get("authCode");

    const { loadImageS, videoDataRef, data_user, userVideos, videosVistosRef } = useProovedorData();

    const videoRef = useRef(null);

    const [vData, setVData] = useState({});
    const [controlVideo, setControlVideo] = useState({
        muted: false,
        time: 0,
        pause: false
    });
    const [commentsData, setCommentsData] = useState({
        active: false,
        newComment: '',
        loading: false,
        uploading: false,
        list: []
    });
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [handleView, setHandleView] = useState({
        activeC: false,
        activeR: false
    });

    const playVideo = () => {
        const videoR = videoRef.current;
        if (!videoR) return;

        setControlVideo((current_obj) => ({
            ...current_obj,
            pause: !videoR.paused
        }))

        if (videoR.paused) videoR.play();
        else videoR.pause();

        if (windowWidth <= 600) disableViews();
    };

    function handleMuted() {
        const videoR = videoRef.current;
        if (!videoR) return;

        videoR.muted = !videoR.muted;

        setControlVideo((current_obj) => ({
            ...current_obj,
            muted: videoR.muted
        }));
    }

    function handleTimeVideo(e) {
        const videoR = videoRef.current;
        if (!videoR) return;

        setControlVideo((current_obj) => ({ ...current_obj, time: e.target.value }));
        videoR.currentTime = e.target.value;
    }

    function progressTime(e) {
        const videoR = videoRef.current;
        if (!videoR) return;

        const a1 = e.target.currentTime;
        const durationV = videoR.duration;
        const porc = parseInt((a1 / durationV) * 100);

        document.documentElement.style.setProperty('--progress-time', String(porc + '%'));
        setControlVideo((current_obj) => ({ ...current_obj, time: a1 }))
    }

    async function getVideoInformation() {
        if (videoDataRef?.[videoKey]) return setVData(videoDataRef[videoKey]);

        const request_fetch = await CallApi({
            url: 'api/user/video/' + videoKey
        });

        if (request_fetch?.code && request_fetch?.code != 200) return;

        setVData(request_fetch);
        videoDataRef[videoKey] = request_fetch;
    }

    const styles_icons = { color: 'var(--color-white)', fontSize: '24px' };
    const styles_icons_mobile = { color: 'var(--color-white)', fontSize: '3.2dvh', filter: 'drop-shadow(0px 6px 4px rgba(0, 0, 0, 1))', padding: '0px' };

    const removeParam = () => {
        videosVistosRef.current = [];
        searchParams.delete("v");
        setSearchParams(searchParams);
        document.documentElement.style.setProperty('--handle-scroll', 'auto');
        document.body.style.overflow = "auto";

        window.removeEventListener('resize', handleResize);
        videoRef.current.removeEventListener("canplay", handleCanPlay);
    };

    function activarFullScreen() {
        const videoR = videoRef.current;
        if (!videoR) return;

        if (videoR.requestFullscreen) videoR.requestFullscreen();
        else if (videoR.webkitRequestFullscreen) videoR.webkitRequestFullscreen();
        else if (videoR.msRequestFullscreen) videoR.msRequestFullscreen();
    }

    async function insertComment() {
        setCommentsData((current_obj) => ({
            ...current_obj,
            uploading: true
        }));

        const fetchInsert = await CallApi({
            url: `api/user/video/${videoKey}`,
            method: 'post',
            body: {
                'comment_text': commentsData.newComment
            }
        });

        if (fetchInsert?.code && fetchInsert.code != 200) return setCommentsData((current_obj) => ({
            ...current_obj,
            uploading: false
        }));

        setVData((current_obj) => ({ ...current_obj, comments: (current_obj?.comments ?? 0) + 1 }));

        setCommentsData((current_obj) => ({
            ...current_obj,
            uploading: false,
            newComment: '',
            list: [
                ...current_obj.list,
                fetchInsert.result
            ]
        }));

        videoDataRef[videoKey] = {
            ...videoDataRef[videoKey],
            comments: videoDataRef[videoKey].comments + 1,
            list_comments: [
                ...videoDataRef[videoKey].list_comments,
                fetchInsert.result
            ]
        };

        const uk = userKey ?? 'me';// user key  
        if (!userVideos?.[uk]?.[vData?.type ?? 'wide']) return;

        userVideos[uk][vData?.type ?? 'wide'] = userVideos[uk][vData?.type ?? 'wide'].map((obj) => obj.file_name == vData.file_name ? ({
            ...obj,
            comments: videoDataRef[videoKey].comments
        }) : obj);

        if (userVideos[uk]?.favorites) {
            userVideos[uk].favorites = userVideos[uk].favorites.map((obj) => obj.file_name == vData.file_name ? ({
                ...obj,
                comments: videoDataRef[videoKey].comments
            }) : obj);
        }
    }

    async function likeVideo() {
        const fetch_like = await CallApi({
            url: `api/user/video/${videoKey}/like`,
            method: 'post'
        });

        if (fetch_like?.code != 200) return;

        setVData((obj) => ({
            ...obj,
            likes: obj.isLiked ? (obj.likes - 1) : (obj.likes + 1),
            isLiked: !obj.isLiked
        }));


        if (!videoDataRef?.[videoKey]) return console.error('Video "' + videoKey + '" no encontrado');

        const keyList = Object.keys(videoDataRef);

        keyList.forEach((vKey) => {
            if (videoDataRef[vKey]?.file_name != vData.file_name) return;

            videoDataRef[vKey] = {
                ...videoDataRef[vKey],
                likes: videoDataRef[vKey].isLiked ? (videoDataRef[vKey].likes - 1) : (videoDataRef[vKey].likes + 1),
                isLiked: !videoDataRef[vKey].isLiked
            };
        });

        const uk = userKey ?? 'me';// user key  
        if (!userVideos?.[uk]?.[vData?.type ?? 'wide']) return;

        userVideos[uk][vData?.type ?? 'wide'] = userVideos[uk][vData?.type ?? 'wide'].map((obj) => obj.file_name == vData.file_name ? ({
            ...obj,
            likes: videoDataRef[videoKey].likes,
            isLiked: videoDataRef[videoKey].isLiked
        }) : obj);

        if (userVideos[uk]?.favorites) {
            userVideos[uk].favorites = userVideos[uk].favorites.map((obj) => obj.file_name == vData.file_name ? ({
                ...obj,
                likes: videoDataRef[videoKey].likes,
                isLiked: videoDataRef[videoKey].isLiked
            }) : obj);
        }
    }

    async function showComments() {
        if (windowWidth <= 600) setHandleView({ activeC: true, activeR: false });

        if (videoDataRef?.[videoKey].list_comments) return setCommentsData((current_obj) => ({
            ...current_obj,
            list: videoDataRef[videoKey].list_comments,
            active: !current_obj.active
        }));

        setCommentsData((current_obj) => ({
            ...current_obj,
            loading: true,
            active: !current_obj.active
        }));

        const getComment = await CallApi({
            url: `api/user/video/${videoKey}/comments`
        });

        if (getComment?.code && getComment?.code != 200) return;

        setCommentsData((current_obj) => ({
            ...current_obj,
            loading: false,
            list: getComment?.code && getComment?.code != 200 ? [] : getComment
        }));

        videoDataRef[videoKey].list_comments = getComment;
    }

    const handleResize = () => setWindowWidth(window.innerWidth);
    const handleCanPlay = () => {
        videoRef.current.play().catch(err => console.error("Autoplay bloqueado:", err));
        setControlVideo((current_obj) => ({
            ...current_obj,
            pause: true
        }))
    }

    useEffect(() => {
        window.addEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (!videoKey) return;

        getVideoInformation();

        setControlVideo({
            muted: false,
            time: 0,
            pause: false
        });

        setCommentsData({
            active: false,
            newComment: '',
            loading: false,
            uploading: false,
            list: []
        });
        disableViews();
        startY.current = null;

        document.documentElement.style.setProperty('--handle-scroll', 'hidden');
        document.body.style.overflow = "hidden";

        const video = videoRef.current;
        if (!video) return;

        video.addEventListener("canplay", handleCanPlay);

        return () => video.removeEventListener("canplay", handleCanPlay);
    }, [videoKey]);

    function disableViews() {
        setHandleView({ activeC: false, activeR: false });
    }

    function copyLinkShare() {
        const url = `${window.location.origin}/user/videos?v=${vData?.video_key ?? ''}`;
        if (!url || !vData?.video_key) return;

        return new Promise((resolve, reject) => {
            if (!navigator.clipboard) {
                reject(new Error('Portapapeles no está disponible'));
                return;
            }

            navigator.clipboard.writeText(url ?? "No se pudo copiar...")
                .then(() => {
                    resolve();
                    toast.success("Enlace copiado exitosamente", {
                        position: 'top-center',
                        closeButton: false,
                        autoClose: 1500,
                        hideProgressBar: false
                    });
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    async function favoriteVideo(obj = null) {
        if (!videoKey) return;

        const fetch_like = await CallApi({
            url: `api/user/video/${videoKey}/favorite`,
            method: 'post'
        });

        if (fetch_like?.code != 200) return;

        setVData((current_obj) => ({ ...current_obj, isFavorite: !current_obj.isFavorite }));

        const uk = userKey ?? 'me';// user key

        if (userVideos[uk]?.[obj.type]) {
            userVideos[uk][obj.type] = userVideos[uk][obj.type].map(vObj => vObj?.file_name == obj?.file_name ? ({
                ...vObj,
                saves: vObj.isFavorite ? (vObj.saves - 1) : (vObj.saves + 1),
                isFavorite: !vObj.isFavorite
            }) : vObj);
        }


        if (userVideos[uk]?.favorites && obj) {
            if (obj.isFavorite) userVideos[uk].favorites = (userVideos[uk]?.favorites ?? []).filter((list_obj) => list_obj.file_name != obj.file_name)
            else userVideos[uk].favorites = [...(userVideos[uk]?.favorites ?? []), {
                ...obj,
                isFavorite: true
            }];
        }

        if (!videoDataRef?.[videoKey]) return;

        videoDataRef[videoKey] = ({
            ...videoDataRef?.[videoKey],
            saves: videoDataRef?.[videoKey].isFavorite ? (videoDataRef?.[videoKey].saves - 1) : (videoDataRef?.[videoKey].saves + 1),
            isFavorite: !videoDataRef?.[videoKey].isFavorite
        });
    }

    const startY = useRef(null);

    const handleTouchStart = (e) => {
        startY.current = e.touches[0].clientY;
    };

    const handleTouchEnd = (e) => {
        if (startY.current === null) return;

        const endY = e.changedTouches[0].clientY;
        const distance = endY - startY.current;

        // Umbral para evitar falsos positivos
        const MIN_SWIPE_DISTANCE = 45;

        if (distance < -MIN_SWIPE_DISTANCE && (vData?.recommended_videos ?? []).length > 0) {
            const objNoFind = (vData?.recommended_videos ?? []).find((obj) => !videosVistosRef.current.includes(obj?.file_name));
            if (!objNoFind) return toast.info('Recomendacion finalizada');
            else videosVistosRef.current.push(objNoFind.file_name);

            const upgradeParams = new URLSearchParams(searchParams);
            upgradeParams.set("v", objNoFind.video_key);
            setSearchParams(upgradeParams);
        }

        startY.current = null;
    };
    if (!videoKey || (typeof videoKey != 'string')) return;

    return (
        <div id='video_viewer'>
            <button className='default-buttons' onClick={removeParam} style={{ zIndex: '2' }}>
                <CloseIcon style={{ color: 'var(--color-fonts-modal)', fontSize: '28px' }} />
            </button>

            {
                windowWidth > 600 ? (
                    <div>
                        <div className='vv-video-media'>
                            <span></span>
                            <div className='vvm-content'>
                                <div style={{ height: 'min-content' }}>
                                    <ProfileContent
                                        profile_url={vData?.profile != 'me' ? vData?.profile : data_user?.perfil}
                                        loadImageS={loadImageS}
                                        style={{ height: 'clamp(40px, 6vw, 52px)' }}
                                    />

                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                        <strong>{vData?.owner_name}</strong>
                                        <span>hace {vData?.date ? diferenciaFechas(vData?.date) : 'poco'}</span>
                                    </div>
                                </div>
                                {/*  */}

                                <div style={{ height: '60vh', width: 'max-content', margin: 'auto' }}>
                                    <video
                                        ref={videoRef}
                                        src={vData?.file_name ? (API_URL + 'media/' + vData.file_name) : null}
                                        onTimeUpdate={progressTime}
                                        onEnded={playVideo}
                                        onClick={playVideo}
                                        controlsList='nodownload'
                                        onContextMenu={(e) => e.preventDefault()}
                                        playsInline
                                    />
                                </div>

                                <div className='vvmc-controls'>
                                    <button className='default-buttons' onClick={playVideo}>
                                        {
                                            !controlVideo?.pause ?
                                                (<PlayArrowIcon style={styles_icons} />)
                                                :
                                                (<PauseIcon style={styles_icons} />)
                                        }
                                    </button>

                                    <input
                                        type='range'
                                        value={controlVideo.time}
                                        onChange={handleTimeVideo}
                                        min={0}
                                        max={videoRef?.current ? videoRef?.current.duration : 100}
                                    />

                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <button type='button' className='default-buttons' onClick={handleMuted}>
                                            {
                                                !controlVideo?.muted ?
                                                    (<VolumeUpIcon style={styles_icons} />)
                                                    :
                                                    (<VolumeMuteIcon style={styles_icons} />)
                                            }
                                        </button>

                                        <button type='button' className='default-buttons' onClick={activarFullScreen}>
                                            <FullscreenIcon style={styles_icons} />
                                        </button>
                                    </div>
                                </div>

                                <div style={{ flexDirection: 'column', alignItems: 'start', width: '100%', gap: '5px' }}>
                                    <strong>{vData?.title}</strong>
                                    <LimitText lineLimit={[1, 3, 5]} style_container={{ width: '100%' }}>
                                        {vData?.description}
                                    </LimitText>
                                </div>
                            </div>

                            <div className={'vvi-comments' + (commentsData?.active ? ' enable-comments' : '')}>
                                <div>
                                    <h3>Comentarios</h3>

                                    <ul>
                                        {
                                            (commentsData.list ?? []).length > 0 ? commentsData.list.map((comment) => (
                                                <li key={comment?.comment_key}>
                                                    <ProfileContent
                                                        profile_url={comment?.profile == 'me' ? data_user?.perfil : comment?.profile}
                                                        loadImageS={loadImageS}
                                                        style={{ height: 'clamp(30px, 5vw, 38px)' }}
                                                    />

                                                    <div>
                                                        <div style={{ flexDirection: 'row' }}>
                                                            <strong>{comment?.user_name ?? ''}</strong>
                                                            <span>hace {comment?.date ? diferenciaFechas(comment?.date) : 'poco'}</span>
                                                        </div>

                                                        <p>{comment?.comment_text ?? ''}</p>
                                                    </div>
                                                </li>
                                            ))
                                                :
                                                (<li>Sé el primero en comentar...</li>)
                                        }
                                    </ul>

                                    <div style={{ width: '100%' }}>
                                        <ProfileContent profile_url={data_user?.perfil} loadImageS={loadImageS} style={{ height: 'clamp(32px, 5vw, 45px)' }} />

                                        <div>
                                            <button type='button' className='default-buttons'>
                                                <MoodIcon style={{ color: 'var(--color-1)', fontSize: '26px' }} />
                                            </button>

                                            <input
                                                type='text'
                                                placeholder='Comentar...'
                                                value={commentsData.newComment}
                                                onChange={(e) => setCommentsData((current_obj) => ({ ...current_obj, newComment: e.target.value }))}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        insertComment();
                                                    }
                                                }}
                                            />

                                            <ButtonLoader onClick={insertComment} state_progress={commentsData.uploading} className='default-buttons'>
                                                <PaperAirplaneIcon main_css={{ width: styles_icons.fontSize }} color='var(--verde)' />
                                            </ButtonLoader>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='lvu-interactions'
                            style={{
                                width: '90%',
                                justifyContent: 'end',
                                position: 'relative',
                                paddingBottom: '10px',
                                borderBottom: '3px solid var(--color-white)'
                            }}
                        >
                            <button className='default-buttons' style={{ gap: '4px' }} onClick={likeVideo}>
                                {
                                    vData?.isLiked ?
                                        (<FavoriteIcon style={styles_icons} />)
                                        :
                                        (<FavoriteBorderIcon style={styles_icons} />)
                                }
                                {vData?.likes ?? 0}
                            </button>

                            <span style={{ gap: '4px', color: styles_icons.color }}>
                                <RemoveRedEyeIcon style={styles_icons} />
                                {vData?.views ?? 0}
                            </span>

                            <button className='default-buttons' style={{ gap: '4px' }} onClick={showComments}>
                                <CommentGlobe color={styles_icons.color} main_css={{ width: styles_icons.fontSize, padding: '0px' }} />
                                {vData?.comments ?? 0}
                            </button>

                            <button className='default-buttons' style={{ gap: '4px' }} onClick={favoriteVideo}>
                                {
                                    vData?.isFavorite ?
                                        (<BookmarkIcon style={{ color: styles_icons.color, fontSize: 'clamp(18px, 2.5vw, 25px)' }} />)
                                        :
                                        (<TurnedInNotIcon style={{ color: styles_icons.color, fontSize: 'clamp(18px, 2.5vw, 25px)' }} />)
                                }
                            </button>

                            <button className='default-buttons' style={{ gap: '4px' }} onClick={copyLinkShare}>
                                <ShareIcon color={styles_icons.color} main_css={{ width: styles_icons.fontSize, padding: '0px' }} />
                            </button>
                        </div>

                        <h3 style={{ width: '100%', color: 'var(--color-white)' }}>Recomendación</h3>
                        <VideoHighWide type={vData?.type ?? 'wide'} list_videos={vData?.recommended_videos ?? []} allow_white={true} />

                        <br></br>
                    </div>
                ) : (
                    <div className='vv-mobile'>
                        <div className={handleView.activeC || handleView.activeR ? 'vvm-active' : 'vvm-inactive'} style={{ height: 'min-content', width: 'calc(100%-30px)', left: '15px', top: '15px' }}>
                            <ProfileContent
                                profile_url={vData?.profile != 'me' ? vData?.profile : data_user?.perfil}
                                loadImageS={loadImageS}
                                style={{ height: 'clamp(40px, 6vw, 52px)' }}
                                className='shadow-lvl2-bottom'
                            />

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                <strong>{vData?.owner_name}</strong>
                                <span>hace {vData?.date ? diferenciaFechas(vData?.date) : 'poco'}</span>
                            </div>
                        </div>

                        <div className={handleView.activeC || handleView.activeR ? 'vvm-active' : 'vvm-inactive'}
                            style={{ flex: 1, overflow: 'hidden', width: handleView.activeC || handleView.activeR ? 'min-content' : '100%' }}
                        >
                            <video
                                ref={videoRef}
                                src={vData?.file_name ? (API_URL + 'media/' + vData.file_name) : null}
                                style={{
                                    height: '100%',
                                    width: '100%',
                                    objectFit: 'contain'
                                }}
                                onTouchStart={handleTouchStart}
                                onTouchEnd={handleTouchEnd}
                                onTimeUpdate={progressTime}
                                onEnded={playVideo}
                                onClick={playVideo}
                                controlsList='nodownload'
                                onContextMenu={(e) => e.preventDefault()}
                                playsInline
                            />
                        </div>

                        <div className='vvm-interactions'>
                            <button className='default-buttons' style={{ gap: '4px' }} onClick={likeVideo}>
                                {
                                    vData?.isLiked ?
                                        (<FavoriteIcon style={styles_icons_mobile} />)
                                        :
                                        (<FavoriteBorderIcon style={styles_icons_mobile} />)
                                }
                                {vData?.likes ?? 0}
                            </button>

                            <span style={{ gap: '4px' }}>
                                <RemoveRedEyeIcon style={styles_icons_mobile} />
                                {vData?.views ?? 0}
                            </span>

                            <button className='default-buttons' style={{ gap: '4px' }} onClick={showComments}>
                                <CommentGlobe color={styles_icons_mobile.color} main_css={{ width: styles_icons_mobile.fontSize, padding: '0px' }} />
                                {vData?.comments ?? 0}
                            </button>

                            <button className='default-buttons' style={{ gap: '4px' }} onClick={favoriteVideo}>
                                {
                                    vData?.isFavorite ?
                                        (<BookmarkIcon style={styles_icons_mobile} />)
                                        :
                                        (<TurnedInNotIcon style={styles_icons_mobile} />)
                                }
                            </button>

                            <button className='default-buttons' style={{ gap: '4px' }} onClick={copyLinkShare}>
                                <ShareIcon color={styles_icons_mobile.color} main_css={{ width: styles_icons_mobile.fontSize, padding: '0px' }} />
                            </button>

                            {/* <span style={{ gap: '4px' }}>
                                <ShareIcon color={styles_icons_mobile.color} main_css={{ width: styles_icons_mobile.fontSize, padding: '0px' }} />
                                {vData?.shared ?? 0}
                            </span> */}
                        </div>

                        <div className={'vvm-information ' + (handleView.activeC ? 'vvm-active' : 'vvm-inactive')}>
                            <div>
                                <span></span>
                                <h3>Comentarios</h3>

                                <button className='default-buttons' onClick={disableViews} style={{ zIndex: '2' }}>
                                    <CloseIcon style={{ color: 'var(--color-fonts-modal)', fontSize: '28px' }} />
                                </button>
                            </div>

                            <ul>
                                {
                                    (commentsData.list ?? []).length > 0 ? commentsData.list.map((comment) => (
                                        <li key={comment?.comment_key}>
                                            <ProfileContent
                                                profile_url={comment?.profile == 'me' ? data_user?.perfil : comment?.profile}
                                                loadImageS={loadImageS}
                                                style={{ height: 'clamp(30px, 5vw, 38px)' }}
                                            />

                                            <div>
                                                <div style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                    <strong>{comment?.user_name ?? ''}</strong>
                                                    <span>hace {comment?.date ? diferenciaFechas(comment?.date) : 'poco'}</span>
                                                </div>

                                                <p>{comment?.comment_text ?? ''}</p>
                                            </div>
                                        </li>
                                    ))
                                        :
                                        (<li>Sé el primero en comentar...</li>)
                                }
                            </ul>

                            <div style={{ gap: '15px' }}>
                                <ProfileContent profile_url={data_user?.perfil} loadImageS={loadImageS} style={{ height: 'clamp(32px, 5vw, 45px)' }} />

                                <div>
                                    <button type='button' className='default-buttons'>
                                        <MoodIcon style={{ color: 'var(--color-1)', fontSize: '26px' }} />
                                    </button>

                                    <input
                                        type='text'
                                        placeholder='Comentar...'
                                        value={commentsData.newComment}
                                        onChange={(e) => setCommentsData((current_obj) => ({ ...current_obj, newComment: e.target.value }))}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                insertComment();
                                            }
                                        }}
                                    />

                                    <ButtonLoader onClick={insertComment} state_progress={commentsData.uploading} className='default-buttons'>
                                        <PaperAirplaneIcon main_css={{ width: styles_icons.fontSize }} color='var(--verde)' />
                                    </ButtonLoader>
                                </div>
                            </div>
                        </div>

                        <div className={'vvm-information ' + (handleView.activeR ? 'vvm-active' : 'vvm-inactive')}>
                            <div>
                                <span></span>
                                <h3>Recomendaciones</h3>

                                <button className='default-buttons' onClick={disableViews} style={{ zIndex: '2' }}>
                                    <CloseIcon style={{ color: 'var(--color-fonts-modal)', fontSize: '28px' }} />
                                </button>
                            </div>

                            <VideoHighWide type={vData?.type ?? 'wide'} list_videos={vData?.recommended_videos ?? []} />
                        </div>


                        <div className='vvm-data'>
                            <div style={{ alignItems: 'center', justifyContent: 'start' }}>
                                <ProfileContent
                                    profile_url={vData?.profile != 'me' ? vData?.profile : data_user?.perfil}
                                    loadImageS={loadImageS}
                                    style={{ height: 'clamp(40px, 6vw, 52px)' }}
                                />

                                <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                    <strong>{vData?.owner_name}</strong>
                                    <span>hace {vData?.date ? diferenciaFechas(vData?.date) : 'poco'}</span>
                                </div>
                            </div>

                            <div style={{ flexDirection: 'column', alignItems: 'start', backgroundColor: 'var(--background-texts)', padding: '5px 10px', borderRadius: '15px' }}>
                                <strong>{vData?.title}</strong>
                                <LimitText lineLimit={[1, 1, 5]} style_container={{ width: '100%' }}>
                                    {vData?.description}
                                </LimitText>
                            </div>

                            <div className='vvmc-controls'>
                                <input
                                    type='range'
                                    value={controlVideo.time}
                                    onChange={handleTimeVideo}
                                    min={0}
                                    max={videoRef?.current ? videoRef?.current.duration : 100}
                                />

                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <button type='button' className='default-buttons' onClick={handleMuted}>
                                        {
                                            !controlVideo?.muted ?
                                                (<VolumeUpIcon style={styles_icons} />)
                                                :
                                                (<VolumeMuteIcon style={styles_icons} />)
                                        }
                                    </button>
                                </div>
                            </div>

                            <div className='recommendations-mobile' onClick={() => setHandleView({ activeC: false, activeR: true })}>
                                <div>
                                    <ListIcon style={styles_icons} />
                                    <span>Recomendación</span>
                                </div>

                                <ArrowForwardIosIcon style={{ ...styles_icons, transform: 'rotate(270deg)' }} />
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    )
}
